var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEllipsis = function SvgEllipsis(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 5"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.186 2.512c0 .968-.858 1.826-1.838 1.826S.534 3.48.534 2.512c0-.98.809-1.838 1.814-1.838.98 0 1.838.87 1.838 1.838m6.115 0c0 .968-.833 1.826-1.813 1.826S6.674 3.48 6.674 2.512c0-.98.821-1.838 1.814-1.838.98 0 1.813.87 1.813 1.838m6.14 0c0 .968-.821 1.826-1.814 1.826-.98 0-1.826-.858-1.826-1.826 0-.98.834-1.838 1.826-1.838s1.814.87 1.814 1.838"
  })));
};
export default SvgEllipsis;